import { httpPublic2 } from "@/api/public";

export const publicRequests = {
  get_all_hcp_practices: function ({ context } = {}) {
    return httpPublic2.post("/v1/practice/all_hcp_practices", { context }).json();
  },

  get_config: function ({ context, searchParams } = {}) {
    return httpPublic2
      .get("/v1/public/get_config", {
        context,
        searchParams: { config_name: searchParams?.feature_name },
      })
      .json();
  },

  get_patient_inactivation_reasons: function ({ context } = {}) {
    return httpPublic2.get("v1/public/get_patient_inactivation_reasons", { context }).json();
  },

  get_policy: function ({ searchParams } = {}) {
    return httpPublic2.get("/v1/public/get_policy", { searchParams }).json();
  },

  update_preferences: function ({ context, searchParams } = {}) {
    return httpPublic2
      .get("/v1/public/update_preferences", {
        context,
        searchParams: { id: searchParams?.id },
      })
      .json();
  },
};
